import { fromJS } from 'immutable';
import {
  RESET_SEARCH_MISSIONS_STORE,
  SET_SEARCH_MISSIONS,
} from 'containers/ExpertHomePage/constants';

export interface SearchMissionsAction {
  type: string;
  missions: any;
}

const initialState: any = fromJS({
  foundMissions: {
    missions: [],
  },
});

const searchMissionsReducer = (
  state = initialState,
  action: SearchMissionsAction,
) => {
  switch (action.type) {
    case SET_SEARCH_MISSIONS:
      return state.set('foundMissions', fromJS(action.missions));
    case RESET_SEARCH_MISSIONS_STORE:
      return initialState;
    default:
      return state;
  }
};

export default searchMissionsReducer;
